import { ComboBox } from "@progress/kendo-react-dropdowns";
import { templateData } from "../../Template/NewTemplateSignals";

export const StageStepProperty = {
  propertyName: "StageStep",
  propertyDisplay: "Show on Template Stage",
  propertyType: "string",
  propertyCategory: "Layout",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <ComboBox
        data={templateData.value.properties.StageSteps}
        onChange={(e) => {
          console.log("onChange");
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        textField="text"
        valueField="id"
        defaultValue={currentPropertyValues?.[this.propertyName] || ""}
        disabled={!templateData.value.properties.StageSteps?.length > 0}
      />
    );
  },
};
